//all the application messages goes here

type messageConfigType = {
    errorMessages: { default: string; [key: string]: string };
    login: any;
};

export const messageConfig: messageConfigType = {
    errorMessages: {
        default: 'Something went wrong, Please try again later', //dont change this key as its being used in multiple places
        'ApolloError: Insufficient Data in Sales Forecast. Try changing the filter or check date selection': 'No data',
        'ApolloError: insufficient_data': 'No Data',
        'ApolloError: QueryExecutionError!': 'Something went wrong. Please try again later!',
        'ApolloError: User needs to modify their selection': 'User needs to modify their selection',
        'No Data': 'No Data',
        'ApolloError: No Data': 'No Data',
        'ApolloError: The number of values in the graph legend is greater than 20. Please reduce the number of selections for Levels':
            'The number of values in the graph legend is greater than 20. Please reduce the number of selections for Levels',
        'User needs to provide atleast 2 values': 'User needs to provide atleast 2 values',
        enterDateRange: 'Please enter Custom Period',
        'ApolloError: Insufficient Data in GrowthAnalysis Forecast. Try changing the filter or check date selection':
            'Insufficient Data in GrowthAnalysis Forecast. Try changing the filter or check date selection',
        'Insufficient data': 'Insufficient Data. Try changing the filter or check date selection',
        'ApolloError: Insufficient Data': 'Insufficient Data',
        'ApolloError: Insufficient data': 'Insufficient Data. Try changing the filter or check date selection',
        'Insufficient data!!': 'No Data',
        NoEditedRecords: 'No Edited Records Found',
        NoMatchingRecords: 'No Records Found',
        iframeScreenUnavailable: 'This screen could not be loaded. Please contact your administrator.',
    },

    login: {
        english: 'ENGLISH',
        // accountLoginMsg: 'Login to your account',
        loginButtonText: 'Sign in',
    },
};
